import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import almacenService from '../../../service/administracion/almacenService';
import establecimientoService from '../../../service/administracion/establecimientoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            establecimientos: [],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idEstablecimiento: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idEstablecimiento: 0,
            codigotipoEstablecimiento:'',
            establecimientos: [],
            tipoEstablecimientos: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            idEstablecimiento: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await almacenService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if(response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await almacenService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await almacenService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await almacenService.eliminar(values);
            else
                response = await almacenService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(
                  <ul>
                    {response.data.messages.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                );
                return;
              }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.establecimientos = this.state.establecimientos;
        formValues.tipoEstablecimientos = this.state.tipoestablecimiento;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await almacenService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    idEstablecimiento: response.idEstablecimiento,
                    establecimientos: this.state.establecimientos,
                    tipoEstablecimientos:this.state.tipoestablecimiento,
                    codigotipoEstablecimiento:values.codigotipoEstablecimiento
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await almacenService.registrar(values);
            else
                response = await almacenService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false});
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, almacenService.paginacion);
        const establecimientos = await establecimientoService.principales();
        const tipoEstablecimientos = await almacenService.listaTipoEstablecimiento('000001')
        this.setState({
            loadingSource: false,
            establecimientos: establecimientos ? establecimientos : [] ,
            tipoestablecimiento: tipoEstablecimientos ? tipoEstablecimientos : [] 

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Almacén"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}